import { FetchDataStoresApi } from 'shared/types';
import { METASTORE_ICON_MAP } from '../IntegrationDialogs/dataCatalog/metastoreIcons';
import multipleDestinationsRenderer from '../../shared/multipleDestinationsRenderer';

const multipleDataCatalogRenderer = ({
  integrations,
  onChange,
}: {
  integrations?: FetchDataStoresApi['integrations'];
  onChange: (option: string, id: string) => void;
}) =>
  multipleDestinationsRenderer({
    integrations:
      integrations?.map((dataStore) => ({
        id: dataStore.id,
        icon: METASTORE_ICON_MAP[dataStore.config.catalog_type] || null,
        name: dataStore.name,
        status: 'connected',
      })) || [],
    onChange,
    options: [
      { value: 'update', label: 'Edit connection' },
      { value: 'delete', label: 'Delete connection' },
    ],
  });
export default multipleDataCatalogRenderer;
